import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import our react pages
import Home from './components/pages/home';
import admin from './components/pages/admin';
// import Mantainance from './components/pages/maitenancePage';
import './css/style.css';
import './scss/style.scss';
// import './worker';

const onUpdate = () => { return window.scrollTo(0, 0); };

ReactDOM.render(
  <Router onUpdate={onUpdate}>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/admin" component={admin} />
      <Route exact path="/upload-hco" component={admin} />
    </Switch>
  </Router>,
  document.getElementById('app'),
);
